module.exports = __webpack_public_path__ + "img/code_436C617564697573.3d0f466d.svg";